type TaskWithDepartamento = {
  id_departamento?: number | string | null;
};

export function buildTaskStatusPayload(
  status: number,
  task?: TaskWithDepartamento | null,
) {
  const payload: { status: number; id_departamento?: number | string } = {
    status,
  };

  if (task?.id_departamento !== undefined && task.id_departamento !== null) {
    payload.id_departamento = task.id_departamento;
  }

  return payload;
}
